// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"b799a7f9","370":"027cdc7d","481":"d212d791","486":"d388f47d","716":"735bbd84","739":"027cdc7d","978":"d212d791"}[chunkId] + ".chunk.css";
};